import { useEffect } from 'react';
import { checkSession } from './services/api/UserApi';
import router from "./routes";
import { getStores } from './stores';
import { toUser } from './core/presenter/transfer/toUser';

function App(): JSX.Element {
  const {userStore} = getStores()

  useEffect(() => {
    const checkUserSession = async () => {
      const { isLoggedIn, user } = await checkSession();
      
      // isLoggedIn이 true일 때만 사용자 정보를 저장
      if (isLoggedIn && user) userStore.setUser(toUser(user));
    };

    checkUserSession();
  }, [userStore]);

  return router;
}

export default App;